import React from "react";

// MUI
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// Components
import BasicInfoCreationSection from "./BasicInfoCreation";
import CustomerPOCCreationSection from "./CustomerPOCCreation";
import GoGetFactors from "./GoGetFactors";
import GoNoGoSection from "./GoNoGoSection";
import ReviewAndSubmitCreation from "./ReviewAndSubmitCreation";
import BidCreationDocumentSection from "../bid-creation-section/right/BidCreationDocumentSection";
import BidCreationCommentsSection from "../bid-creation-section/right/BidCreationCommentsSection";

// Typess
import { Mode, AddEdit } from "../../../SectionWiseClassification";

type Props = {
  steps: string[];
  activeStep: number;
  mode: Mode;
  type: AddEdit;
  isGoNoGo: boolean;
};

function BidPipeLineSection({
  steps,
  activeStep,
  mode,
  type,
  isGoNoGo,
}: Props) {
  return (
    <Box>
      <Stepper
        activeStep={activeStep}
        sx={{ display: { xs: "none", sm: "flex" } }}
      >
        {steps.map((label) => {
          return (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          display: { xs: "block", sm: "none" },
        }}
      >
        {steps[activeStep]}:
      </Typography>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          {activeStep === 0 ? (
            <BasicInfoCreationSection type={type} />
          ) : activeStep === 1 ? (
            <CustomerPOCCreationSection type={type} />
          ) : activeStep === 2 ? (
            <GoGetFactors type={type} />
          ) : activeStep === 3 ? (
            isGoNoGo ? (
              <GoNoGoSection />
            ) : (
              <ReviewAndSubmitCreation />
            )
          ) : activeStep === 4 ? (
            <ReviewAndSubmitCreation />
          ) : null}
        </Grid>
        <Grid item xs={12}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Box
              sx={{
                border: "1px solid rgb(0 0 0 / 18%)",
                borderRadius: "0.375rem",
                flex: 1,
              }}
            >
              <BidCreationDocumentSection />
            </Box>
            {mode === "user" ? (
              <Box
                sx={{
                  border: "1px solid rgb(0 0 0 / 18%)",
                  borderRadius: "0.375rem",
                  flex: 1,
                }}
              >
                <BidCreationCommentsSection />
              </Box>
            ) : null}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default BidPipeLineSection;
